<template>
    <div class="page">
      <Header />
      <router-view></router-view>
      <Footer />
    </div>
</template>
<script>
import Utils from './../../js/helpers/Utils';
import Header from './header';
import Footer from './footer';

export default {
    mounted(){
        window.$("header").ready(() => {
            setTimeout(() => {
                if(window.top.document.querySelector("header").clientHeight <= 0){
                    Utils.loadHeader();
                }
            }, 200);
        });
    },
    components: {
        Header,
        Footer
    }
}
</script>
